import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import styled from "styled-components";
import { zIndex } from "./zIndex.js";
function NotificationPosition({
  toast,
  calculateOffset,
  updateHeight
}) {
  const offset = calculateOffset(toast, {
    reverseOrder: false,
    gutter: 16
    // had to use hard coded value, because it needs to be a number
  });
  const isItJustAdded = typeof toast.height === "undefined";
  const isExists = typeof toast.height !== "undefined" && toast.visible;
  const isDismissed = typeof toast.height !== "undefined" && !toast.visible;
  const [offsetForDismissAnimation, setOffsetForDismissAnimation] = useState(offset);
  if (offset !== offsetForDismissAnimation && !isDismissed) {
    setOffsetForDismissAnimation(offset);
  }
  function ref(el) {
    if (el && typeof toast.height === "undefined") {
      const height = el.getBoundingClientRect().height;
      updateHeight(toast.id, height);
    }
  }
  return /* @__PURE__ */ jsx(NotificationPositionStyled, {
    ref,
    $isExists: isExists,
    $isItJustAdded: isItJustAdded,
    $isDismissed: isDismissed,
    $isVisible: toast.visible,
    $offset: isDismissed ? offsetForDismissAnimation : offset,
    children: typeof toast.message === "function" ? toast.message(toast) : toast.message
  });
}
const NotificationPositionStyled = styled.div.withConfig({
  displayName: "NotificationPositionStyled",
  componentId: "sc-5rpzyh-0"
})(["position:absolute;bottom:0;left:0;z-index:", ";opacity:", ";transition:all 0.2s ease-out;transform:translateY(", "px) translate3d(0,", ",0) translateX(", ");will-change:transform,opacity;"], (props) => props.$isVisible ? zIndex : void 0, (props) => props.$isExists ? "1" : "0", (props) => props.$offset * -1, (props) => props.$isItJustAdded ? "calc(100% + 16px)" : "0", (props) => props.$isDismissed ? "-100%" : "0");
export {
  NotificationPosition
};
//# sourceMappingURL=NotificationPosition.js.map
